<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">Post 리스트</div>
                    <elastic-list-component :elasticType="'post'"></elastic-list-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ElasticListComponent from "@/components/elastic/ElasticListComponent";
export default {
    name: "Post",
    mixins: [],
    components: {
        ElasticListComponent
    },
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>
